import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Box, IconButton, Typography } from "@mui/material";
import { ReactElement, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

type PdfViewerProps = {
  source: string;
  scale?: number;
  showButtons?: boolean;
  fallback?: ReactElement;
};

const PdfViewer = ({
  source,
  scale = 1,
  showButtons = true,
  fallback,
}: PdfViewerProps) => {
  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [failed, setFailed] = useState(false);

  const nextPage = () => {
    setPageNumber((prev) => prev + 1);
  };

  const previousPage = () => {
    setPageNumber((prev) => prev - 1);
  };

  return fallback && failed ? (
    fallback
  ) : (
    <Box width={"100%"}>
      <Box
        onClick={() => window.open(source, "_blank")}
        sx={{ cursor: "pointer" }}
      >
        <Document
          file={source}
          loading={fallback}
          onLoadSuccess={(pdf) => setNumPages(pdf.numPages)}
          onLoadError={() => setFailed(true)}
        >
          <Page scale={scale} pageNumber={pageNumber} />
        </Document>
      </Box>

      {numPages > 1 && showButtons && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <IconButton disabled={pageNumber <= 1} onClick={previousPage}>
            <NavigateBeforeIcon />
          </IconButton>
          <Typography variant="subtitle2">
            {`Page ${pageNumber || (numPages ? 1 : "--")} of ${
              numPages || "--"
            }`}
          </Typography>
          <IconButton disabled={pageNumber >= numPages} onClick={nextPage}>
            <NavigateNextIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default PdfViewer;
